import React from 'react';
import { useAuth } from '../../AuthContext';

const LoadingOverlay = ({ open = true, message = 'Loading...' }) => {
  const { companyName } = useAuth();

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(240, 244, 248, 0.6)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      gap: 36,
    }}>
      {/* Logo blocks — 3D flip reveal in sequence */}
      <div style={{ position: 'relative', width: 90, height: 74, perspective: 400 }}>
        {/* Green */}
        <div style={{
          position: 'absolute', width: 36, height: 36, background: '#3aaa5c',
          borderRadius: 6, bottom: 0, left: 0,
          animation: 'tileFlip 2s ease-in-out infinite',
          animationDelay: '0s',
          boxShadow: '0 0 24px rgba(58,170,92,0.6)',
        }} />
        {/* Blue */}
        <div style={{
          position: 'absolute', width: 30, height: 52, background: '#2d6db5',
          borderRadius: 6, bottom: 0, left: 30,
          animation: 'tileFlip 2s ease-in-out infinite',
          animationDelay: '0.3s',
          boxShadow: '0 0 24px rgba(45,109,181,0.6)',
        }} />
        {/* Red */}
        <div style={{
          position: 'absolute', width: 34, height: 34, background: '#cc2b2b',
          borderRadius: 6, top: 0, right: 0,
          animation: 'tileFlip 2s ease-in-out infinite',
          animationDelay: '0.6s',
          boxShadow: '0 0 24px rgba(204,43,43,0.6)',
        }} />
        {/* Orange */}
        <div style={{
          position: 'absolute', width: 34, height: 34, background: '#e8a020',
          borderRadius: 6, bottom: 0, right: 0,
          animation: 'tileFlip 2s ease-in-out infinite',
          animationDelay: '0.9s',
          boxShadow: '0 0 24px rgba(232,160,32,0.6)',
        }} />
      </div>

      {/* Company name with shimmer */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: 24, fontWeight: 800, color: 'transparent',
          letterSpacing: 3, textTransform: 'uppercase',
          fontFamily: 'Verdana, sans-serif',
          background: 'linear-gradient(90deg, #3aaa5c, #2d6db5, #cc2b2b, #e8a020, #3aaa5c)',
          backgroundSize: '300% auto',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: 'shimmerText 2.5s linear infinite',
        }}>
          {companyName || 'ERP'}
        </div>
        <div style={{ fontSize: 11, color: 'rgba(30,40,80,0.5)', marginTop: 8, letterSpacing: 2, textTransform: 'uppercase' }}>
          {message}<span style={{ animation: 'dots 1.5s steps(3,end) infinite' }}>...</span>
        </div>
      </div>

      {/* Dot indicators */}
      <div style={{ display: 'flex', gap: 8 }}>
        {['#3aaa5c', '#2d6db5', '#cc2b2b', '#e8a020'].map((c, i) => (
          <div key={i} style={{
            width: 8, height: 8, borderRadius: '50%', background: c,
            animation: 'dotPulse 1.2s ease-in-out infinite',
            animationDelay: `${i * 0.2}s`,
          }} />
        ))}
      </div>

      <style>{`
        @keyframes tileFlip {
          0%   { transform: rotateY(0deg) scale(1); opacity: 1; }
          25%  { transform: rotateY(90deg) scale(0.8); opacity: 0.3; }
          50%  { transform: rotateY(180deg) scale(1); opacity: 1; }
          75%  { transform: rotateY(270deg) scale(0.8); opacity: 0.3; }
          100% { transform: rotateY(360deg) scale(1); opacity: 1; }
        }
        @keyframes shimmerText {
          0%   { background-position: 0% center; }
          100% { background-position: 300% center; }
        }
        @keyframes dotPulse {
          0%, 100% { transform: scale(1); opacity: 0.4; }
          50%       { transform: scale(1.6); opacity: 1; }
        }
        @keyframes dots {
          0%   { content: '.'; }
          33%  { content: '..'; }
          66%  { content: '...'; }
        }
      `}</style>
    </div>
  );
};

export default LoadingOverlay;
